import { GridColumnItem } from '@aex/shared/common-lib';
import { Injectable } from '@angular/core';
import { ColumnReorderEvent } from '@progress/kendo-angular-grid';

@Injectable({
	providedIn: 'root',
})
export class SearchGridService {

	public gridColumnReorderEvent(event: ColumnReorderEvent, visibleColumns: GridColumnItem[], showCheckBox: boolean = true): GridColumnItem[] {
		let sourceIndex = event.oldIndex - 1;
		let targetIndex = event.newIndex - 1;
		if (!showCheckBox) {
			sourceIndex = event.oldIndex;
			targetIndex = event.newIndex;
		}

		// Reorder the records in the visibleColumns array
		const reorderedColumns = [...visibleColumns];
		const [removed] = reorderedColumns.splice(sourceIndex, 1);
		reorderedColumns.splice(targetIndex, 0, removed);

		// Updated the columns array
		return [...reorderedColumns];
	}

	public resetGridColumns(
		selectableColumns: string[],
		columns: GridColumnItem[],
	): { filteredGridColumns: string[]; selectedColumns: string[]; visibleColumns: GridColumnItem[] } {
		const filteredGridColumns = [...selectableColumns];
		const gridColumns = [...columns];

		const selectedColumns = [...gridColumns]
		.filter((column) => !column.hidden)
		.map((column) => column.title);

		const visibleColumns = [...gridColumns];

		return { filteredGridColumns, selectedColumns, visibleColumns };
	}
}
